export default __webpack_public_path__ + "static/media/vn.7601c8ac.svg";